import CreditIcon from "@/assets/icons/CreditCoin.svg";
import VideoPlayIcon from "@/assets/icons/VideoPlayIconOrder.svg";
import ClockIcon from "@/assets/icons/ClockIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import { formatDate, formatSameDayDelivery } from "@/utils/formateData";
import {
  TResponseDraftOrderDetails,
  TResponseOrderDetails,
  TResponseTemplateDraftOrder,
} from "@/types/projectType";
import { useAppDispatch } from "@/redux/hooks/hooks";
import { TCreatorProjectResponseType, TFilterOptions } from "../Projects";

interface MobileOrderCardProps {
  item: TCreatorProjectResponseType;
  filter: TFilterOptions;
}

const MobileProjectCard = ({ item, filter }: MobileOrderCardProps) => {
  const order = item?.order_id;
  const defaultVideoId = item?.videoIds?.[0] ?? "1";

  const orderStatus = order?.orderStatus?.isPending ? (
    <p className="bg-[#DFEAF4] text-[#003471] text-xs leading-[18px] tracking-[-3%] font-medium border-[#DFEAF4] border rounded-[32px] px-2 py-[2px] inline-block">
      Pending
    </p>
  ) : order?.orderStatus?.isProgress ? (
    <p className="bg-[#FBF1DA] text-[#714B00] text-xs leading-[18px] tracking-[-3%] font-medium border-[#714B0029] border rounded-[32px] px-2 py-[2px] inline-block">
      Pending
    </p>
  ) : order?.orderStatus?.isCompleted ? (
    <p className="bg-[#E9F5EF] text-[#1D7100] text-xs leading-[18px] tracking-[-3%] font-medium border-[#1D71002E] border rounded-[32px] px-2 py-[2px] inline-block">
      Completed
    </p>
  ) : (
    "Unknown"
  );
  const deadline = order?.isSameDayFlow
    ? formatSameDayDelivery(order?.deadline)
    : formatDate(order?.deadline);

  return (
    <div className="md:hidden border border-[#E4E7EC] rounded-xl mb-4 w-full md:max-w-[330px]">
      <div className="p-4">
        <div className="flex justify-between items-center">
          <h5 className="font-semibold text-base leading-6 tracking-[-2.5%]">
            {item?.order_id?.projectName}
          </h5>
          <div>
            {orderStatus}
          </div>
        </div>
        <div className="flex gap-2 items-center mt-2 mb-4">
          <p className="text-[#98A2B3] text-sm font-medium tracking-[-2.5%] leading-4">
            {item?.order_id?.clientId?.businessName}
          </p>
          <HorizontalDivider />
          <p className="text-[#98A2B3] capitalize text-sm font-medium tracking-[-2.5%] leading-4">
            {item?.order_id?.clientId?.industry}
          </p>
        </div>
        {/* <PlanningStatusBadge stageStatus={"-"} /> */}
        <div className="flex justify-between items-center">
          {/* <div className="space-y-2.5">
            <p className="text-[#97979B] text-xs leading-[18px] font-medium">
              Due in
            </p>
            <p className="text-[#1D2939] text-[13px] leading-[18px] tracking-[-3%] font-medium">
              32 hours
            </p>
          </div> */}
          <div className="space-y-2.5">
            <p className="text-[#97979B] text-xs leading-[18px] font-medium">
              Deadline on
            </p>
            <p className="text-[#1D2939] text-[13px] leading-[18px] tracking-[-3%] font-medium">
              {deadline}
            </p>
          </div>
        </div>
        <div className="flex justify-wrap gap-2">
          {/* <div className="mt-4 flex items-center gap-1 bg-[#F2F4F7] border border-[#F2F4F7] px-2 py-1 rounded-[4px] whitespace-nowrap">
            <span className="text-[#788193] font-medium text-xs leading-4 tracking-[-1.5%]">
              RS. 4400
            </span>
          </div> */}
          <div className="mt-4 flex items-center gap-1 bg-[#F2F4F7] border border-[#F2F4F7] px-2 py-1 rounded-[4px] whitespace-nowrap">
            <VideoPlayIcon />
            <span className="text-[#788193] font-medium text-xs leading-4 tracking-[-1.5%]">
              {order?.orderVideos?.length}{" "}
              {order?.orderVideos?.length > 1 ? "Videos" : "Video"}
            </span>
          </div>
          <div className="mt-4 flex items-center gap-1 bg-[#F2F4F7] border border-[#F2F4F7] px-2 py-1 rounded-[4px] whitespace-nowrap">
            <ClockIcon />
            <span className="text-[#788193] font-medium text-xs leading-4 tracking-[-1.5%]">
              {order?.orderVideos[0]?.scriptDetails?.videoLength?.label}
            </span>
          </div>
        </div>
      </div>
      <div className="border-t-2 flex justify-end border-[#f4f4f4]">
        <div className="px-4 py-3 flex justify-between items-center">
          <Link
            to={`/orders/order-management/${item?.order_id?._id}?videoId=${defaultVideoId}&p_id=${item?._id}`}
          >
            <p className="text-[#ED5E00] whitespace-nowrap  text-xs leading-[18px] cursor-pointer px-3">
              View Details
            </p>
          </Link>
        </div>
      </div>
    </div>
  );
};

const HorizontalDivider = () => {
  return <div className="w-[2px] h-3 bg-[#98A2B3]"></div>;
};

export default MobileProjectCard;